<mat-card class="product-card">
  <mat-card-content>
    <nav mat-tab-nav-bar class="navigation-tabs" [tabPanel]="tabPanel">
      <a
        mat-tab-link
        [routerLink]="['./general']"
        routerLinkActive
        #general="routerLinkActive"
        [active]="general.isActive"
      >
        {{ 'labels.inputs.General' | translate }}
      </a>
      @for (shareProductDatatable of shareProductDatatables; track shareProductDatatable) {
        <a
          mat-tab-link
          [routerLink]="['./datatables', shareProductDatatable.registeredTableName]"
          routerLinkActive
          #datatable="routerLinkActive"
          [active]="datatable.isActive"
          *LOSxHasPermission="'READ_' + shareProductDatatable.registeredTableName"
        >
          {{ shareProductDatatable.registeredTableName }}
        </a>
      }
    </nav>

    <mat-tab-nav-panel #tabPanel>
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  </mat-card-content>
</mat-card>
